module.exports = __webpack_public_path__ + "static/media/ic_closed_finger.442e2f95.svg";